import type { PrivacyNotice } from '@fleet/shared';

/**
 * Der Text der Datenschutzhinweise.
 *
 * Getrennt von Seite und Dialog, weil er an beiden Stellen derselbe sein muss.
 * Eine Kurzfassung im Buchungsformular und eine ausführliche auf einer
 * Unterseite wären zwei Texte, die auseinanderlaufen — und bestätigt würde
 * derjenige, den niemand pflegt.
 */
export function PrivacyNoticeBody({ notice }: { notice: PrivacyNotice }) {
  return (
    <div className="space-y-5">
      {notice.sections.map((section) => (
        <section
          key={section.id}
          className={
            section.emphasis
              ? 'rounded-md border border-slate-200 bg-slate-50 px-4 py-3.5'
              : undefined
          }
        >
          <h3 className="text-sm font-semibold">{section.heading}</h3>

          {section.paragraphs.map((paragraph, index) => (
            <p key={index} className="mt-2 text-sm leading-relaxed text-slate-600">
              {paragraph}
            </p>
          ))}

          {section.bullets && (
            <ul className="mt-2 space-y-1.5">
              {section.bullets.map((bullet) => (
                <li
                  key={bullet}
                  className="flex gap-2 text-sm leading-relaxed text-slate-600"
                >
                  <span aria-hidden className="mt-2 size-1 shrink-0 rounded-full bg-slate-400" />
                  <span>{bullet}</span>
                </li>
              ))}
            </ul>
          )}
        </section>
      ))}

      <p className="border-t border-slate-200 pt-4 font-mono text-xs text-slate-400">
        Fassung {notice.version}
      </p>
    </div>
  );
}
